export default __webpack_public_path__ + "static/media/mic_icon.6d19295a.svg";